import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { GoogleSearchConsoleReconnectButton } from './GoogleSearchConsoleReconnectButton';
import { GoogleSearchConsoleServiceComponent } from './GoogleSearchConsoleServiceComponent';
export const GoogleSearchConsoleReconnectionConfig = {
  reconnectButton: GoogleSearchConsoleReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.UPDATE_AVAILABLE],
  serviceComponent: GoogleSearchConsoleServiceComponent
};